import React, { useState, useEffect, useContext } from "react";
import { FaSort } from "react-icons/fa";
import {
  Box,
  FormControl,
  OutlinedInput,
  Paper,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  MenuItem,
  Button,
  TablePagination,
} from "@mui/material";
import { styled } from "@mui/system";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Table } from "react-bootstrap";
import PwCheckPopup from "./user/answer/PwCheckPopup";
import DataContext from "../../context/users/DataContextCopy";

// 텍스트 필드, 메뉴아이템 커스터마이징
const CustomFormControl = styled(FormControl)`
  && {
    & .MuiInputBase-root {
      border: 1px solid #ddd;
      color: #f4f5f5;
      background-color: #ddd;
      text-align: left;
      height: 47.78px;
    }

    & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: #f4f5f5;
    }

    & .MuiSelect-icon {
      color: #f4f5f5;
    }
  }
`;
const CustomOutlinedInput = styled(OutlinedInput)`
  && {
    background-color: #0067b6 !important;
    color: #f4f5f5;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    &:hover {
      background-color: #244ea2 !important;
    }

    & .MuiListItemIcon-root {
      min-width: 32px;
    }
  }
`;

const CustomChipBox = styled(Box)`
  && {
    display: flex;
    flex-wrap: wrap;
  }
`;

const CustomMenuItem = styled(MenuItem)`
  && {
    font-weight: ${({ selected, theme }) =>
      selected
        ? theme.typography.fontWeightMedium
        : theme.typography.fontWeightRegular};
  }
`;
const theme = createTheme();

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0067b6",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const DeclareList = () => {
  const {
    // 내 민원 확인
    myList,
    sdate,
    edate,
    setSdate,
    setEdate,
    setNum,
    setUserPwdCheck,
  } = useContext(DataContext);

  // 최신순
  const [sortColumn, setSortColumn] = useState(null); // 정렬 기준 열
  const [sortDirection, setSortDirection] = useState(null); // 정렬 방향

  // 1. 악취 강도 선택할 수 있는 토글 (톱니바퀴)
  // 악취 강도 선택 상자의 표시 여부 관리
  const [showIntensitySelect, setShowIntensitySelect] = useState(false);
  // 사용자가 선택한 악취 강도를 저장
  const [selectedIntensity, setSelectedIntensity] = useState(["전체"]);
  // console.log(odorReports);
  const [filteredData, setFilteredData] = useState([...myList]); // 상태 변수로 변경

  const handleIntensityChange = (event) => {
    const { value } = event.target;

    // 전체가 선택된 상태에서 다른 옵션이 클릭되면 '전체' 선택을 해제하고 선택된 항목만 남김
    if (selectedIntensity.includes("전체")) {
      setSelectedIntensity(value.filter((item) => item !== "전체"));
    } else {
      // '전체'를 제외한 다른 옵션을 선택하면 '전체' 옵션을 해제
      setSelectedIntensity(value);
    }
  };

  // 악취 강도 선택 상자를 토글
  const handleToggleIntensitySelect = () => {
    setShowIntensitySelect(!showIntensitySelect);
  };

  const intensityOptions = [
    { label: "전체", value: "전체" },
    { label: "(0) 무취", value: "무취" },
    { label: "(1) 약간느낌", value: "약간느낌" },
    { label: "(2) 보통냄새", value: "보통냄새" },
    { label: "(3) 강한냄새", value: "강한냄새" },
    { label: "(4) 극심한냄새", value: "극심한냄새" },
    { label: "(5) 참기어려운냄새", value: "참기어려운냄새" },
  ];

  const equivalentValues = {
    전체: [
      "전체",
      "무취",
      "약간느낌",
      "보통냄새",
      "강한냄새",
      "극심한냄새",
      "참기어려운냄새",
    ],
    "무취 - 평상시 후각으로 아무것도 감지하지 못하는 정도": "무취",
    "약간느낌 - 무슨 냄새인지 알 수 없으나 약간의 냄새를 느낄 수 있는 정도":
      "약간느낌",
    "보통냄새 - 무슨 냄새인지 알 수 있는 정도": "보통냄새",
    "강한냄새 - 쉽게 감지할 수 있는 정도의 강한 냄새, 병원의 크레졸 냄새 수준":
      "강한냄새",
    "극심한냄새 - 아주 강한 냄새, 여름철 재래식 화장실냄새 수준": "극심한취기",
    "참기어려운냄새 - 견디기 어려운 강렬한 냄새로써 호흡이 정지될 것 같은 수준":
      "극심한냄새",
  };

  // 3. 항목별 필터링

  const applyFilters = () => {
    let newData = [...myList]; // newData 변수 초기화

    // 필터링 로직
    if (selectedIntensity.includes("전체")) {
      // 전체 강도 선택 시 모든 데이터 유지
      newData = [...myList];
    } else {
      newData = newData.filter((report) => {
        const intensity = equivalentValues[report.div_name] || report.div_name;
        return selectedIntensity.includes(intensity); // 선택한 강도에 해당하는 데이터 필터링
      });
    }

    /* 
     정렬 기준에 따른 정렬, 정렬 로직 추가
      sortColumn과 sortDirection 값이 모두 존재하는 경우,
      filteredData를 해당 기준으로 정렬.
      오름차순(asc) 또는 내림차순(desc) 방향으로 정렬.
    */

    if (selectedIntensity.length > 0 && !selectedIntensity.includes("전체")) {
      newData = newData.filter((report) => {
        const intensity = equivalentValues[report.div_name] || report.div_name;
        return selectedIntensity.includes(intensity);
      });
    }

    if (sortColumn && sortDirection) {
      newData = newData.sort((a, b) => {
        if (a[sortColumn] < b[sortColumn])
          return sortDirection === "asc" ? -1 : 1;
        if (a[sortColumn] > b[sortColumn])
          return sortDirection === "asc" ? 1 : -1;
        return 0;
      });
    }
    // 필터링 및 정렬된 목록을 설정
    setFilteredData(newData);
  };

  // 4. 최신순 기능
  const handleSortColumn = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
  };

  const compareByAnswerStatus = (statusA, statusB) => {
    if (statusA === null && statusB !== null) {
      return sortDirection === "asc" ? -1 : 1; // 미답변이 먼저 오도록 정렬
    } else if (statusA !== null && statusB === null) {
      return sortDirection === "asc" ? 1 : -1; // 답변이 먼저 오도록 정렬
    } else {
      return 0; // 상태가 같으면 변화 없음
    }
  };

  useEffect(() => {
    applyFilters();
  }, [selectedIntensity, sdate, edate, sortColumn, sortDirection, myList]);

  // 5. 페이지네이션
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  //비밀번호 체크모달
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleClick = (item) => {
    handleOpen(); // 모달 열기
    setNum(item.mw_id); // 클릭된 항목의 mw_id 설정
    setUserPwdCheck(""); // 입력 필드 초기화
  };

  return (
    <ThemeProvider theme={theme}>
      <PwCheckPopup open={open} handleClose={handleClose} />
      <main className='declarelist-container'>
        <div className='declarelist-box'>
          <div className='declarelist-contents'>
            <div className='declare-title'>
              <div className='title'>
                <h1>나의 악취 신고 목록</h1>
              </div>
            </div>

            {/* <div className="date-select">
              <div className="date-bundle">
                <input
                  type="date"
                  id="date"
                  name="date"
                  aria-label="시작날짜"
                  value={sdate}
                  onChange={(e) => setSdate(e.target.value)}
                />
                <span>to</span>
                <input
                  type="date"
                  id="date"
                  name="date"
                  aria-label="종료날짜"
                  value={edate}
                  onChange={(e) => setEdate(e.target.value)}
                />
              </div>
              <div className="moreView" onClick={handleToggleIntensitySelect}>
                <FaFilter
                  className={`settings-icon ${
                    showIntensitySelect ? "active" : ""
                  }`}
                />
                <p>강도별</p>
              </div>
            </div> */}

            {/* 악취 강도 선택 box */}
            {/* 
            {showIntensitySelect && (
              <CustomFormControl>
                <InputLabel htmlFor="multiple-chip-label">
                  악취 강도별 신고 결과 보기
                </InputLabel>
                <Select
                  labelid="multiple-chip-label"
                  id="multiple-chip"
                  multiple
                  value={selectedIntensity}
                  onChange={handleIntensityChange}
                  input={
                    <CustomOutlinedInput
                      id="select-multiple-chip"
                      label="Chip"
                    />
                  }
                  renderValue={(selected) => (
                    <CustomChipBox>
                      {selected.map((value) => (
                        <Chip key={value} label={value} />
                      ))}
                    </CustomChipBox>
                  )}
                >
                  {intensityOptions.map((option) => (
                    <CustomMenuItem
                      key={option.value}
                      value={option.value}
                      selected={selectedIntensity.includes(option.value)}
                    >
                      {option.value}
                    </CustomMenuItem>
                  ))}
                </Select>
              </CustomFormControl>
            )} */}

            <ThemeProvider theme={theme}>
              <TableContainer className='tableContainer' component={Paper} style={{ paddingTop: 30 }}>
                <Table className='list-table'>
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>
                        신고일
                        <FaSort className={`sort-icon ${sortColumn === 'rcpt_date' ? 'active' : ''}`} onClick={() => handleSortColumn('rcpt_date')} />
                      </StyledTableCell>
                      <StyledTableCell>
                        지역
                        <FaSort className={`sort-icon ${sortColumn === 'rpt_addr' ? 'active' : ''}`} onClick={() => handleSortColumn('rpt_addr')} />
                      </StyledTableCell>
                      <StyledTableCell>
                        악취 종류
                        <FaSort className={`sort-icon ${sortColumn === 'mw_typ' ? 'active' : ''}`} onClick={() => handleSortColumn('mw_typ')} />
                      </StyledTableCell>
                      <StyledTableCell>
                        악취 강도
                        <FaSort className={`sort-icon ${sortColumn === 'div_name' ? 'active' : ''}`} onClick={() => handleSortColumn('div_name')} />
                      </StyledTableCell>

                      <StyledTableCell>
                        작성자
                        <FaSort className={`sort-icon ${sortColumn === 'rpt_nm' ? 'active' : ''}`} onClick={() => handleSortColumn('rpt_nm')} />
                      </StyledTableCell>

                      <StyledTableCell>
                        답변확인
                        <FaSort
                          className={`sort-icon ${sortColumn === 'proc_rs' ? 'active' : ''}`}
                          onClick={() => compareByAnswerStatus('proc_rs')}
                        />
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredData?.length !== 0 ? (
                      filteredData?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(item => (
                        <StyledTableRow key={item.id} onClick={() => handleClick(item)}>
                          <StyledTableCell>{item.rcpt_date.substring(0, 16)}</StyledTableCell>
                          <StyledTableCell>{window.innerWidth < 600 ? item.rpt_addr.substring(0, 14) + '...' : item.rpt_addr}</StyledTableCell>
                          <StyledTableCell>{item.type_name}</StyledTableCell>
                          <StyledTableCell>{window.innerWidth < 600 ? item.div_name : item.div_name}</StyledTableCell>
                          <StyledTableCell>{item.rpt_nm}</StyledTableCell>
                          <StyledTableCell>
                            {item.proc_rs === null ? <Button color={'warning'}>미답변</Button> : <Button>답변완료</Button>}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))
                    ) : (
                      <StyledTableRow>
                        <StyledTableCell colSpan={6}>기간 내에 등록된 신고목록이 없습니다.</StyledTableCell>
                      </StyledTableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </ThemeProvider>

            {/* 페이지네이션 */}

            <TablePagination
              sx={{ minWidth: '100%' }}
              variant='outlined'
              rowsPerPageOptions={[5, 10, 20, 100]}
              component='div'
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              style={{
                width: '100%',
                backgroundColor: '#0067b6',
                color: '#fff',
              }}
              size={'small'}
            />
          </div>
        </div>
      </main>
    </ThemeProvider>
  );
};

export default DeclareList;
